const priceFormatter = new Intl.NumberFormat('fr-CA', {
    style: 'currency',
    currency: 'CAD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

const numberFormatter = new Intl.NumberFormat('fr-CA', {
    maximumFractionDigits: 2,
});

const dateFormatter = new Intl.DateTimeFormat('fr-CA', {
    year: 'numeric', month: 'short', day: 'numeric',
});

export function formatPrice(value) {
    const n = Number(value ?? 0);
    return priceFormatter.format(Number.isFinite(n) ? n : 0);
}

// Prix à la pièce : souvent sous 1 $ (une caisse de 20 à 18,46 $ tombe à
// 0,923 $ l'unité). À deux décimales, deux produits distincts s'affichent
// identiques — on en garde trois sous 1 $ pour que la comparaison serve.
const unitPriceFormatter = new Intl.NumberFormat('fr-CA', {
    style: 'currency',
    currency: 'CAD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 3,
});

export function formatUnitPrice(value) {
    const n = Number(value ?? 0);
    if (!Number.isFinite(n)) return priceFormatter.format(0);
    return n < 1 ? unitPriceFormatter.format(n) : priceFormatter.format(n);
}

export function formatNumber(value) {
    const n = Number(value ?? 0);
    return numberFormatter.format(Number.isFinite(n) ? n : 0);
}

export function formatDate(value) {
    if (!value) return '—';
    try {
        return dateFormatter.format(new Date(value));
    } catch {
        return '—';
    }
}

export const ORDER_STATUS_FR = {
    DRAFT: 'En préparation',
    ORDERED: 'Confirmée',
    INVOICED: 'Facturée',
    PICKED: 'Préparée',
    PARTIALLY_SHIPPED: 'Partiellement expédiée',
    SHIPPED: 'Expédiée',
    CANCELLED: 'Annulée',
    BACKORDER: 'En reliquat',
};

export function orderStatusLabel(status) {
    return ORDER_STATUS_FR[status] || status || '—';
}
